export const roundNumber = (value: number, numberOfDecimals: number = 2) => {
  const factor = Math.pow(10, numberOfDecimals);
  const valueToRound = value * factor;
  const flooredValue = Math.floor(valueToRound);

  if (valueToRound - flooredValue !== 0.5) {
    return Math.round(valueToRound) / factor;
  }

  return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / factor;
};
